import script from "./QModalDeleteConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalDeleteConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./QModalDeleteConfirmation.vue?vue&type=style&index=0&id=f5b47bd4&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5b47bd4"]])

export default __exports__